import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';

import s from './Button.scss';

@withStyles(s)
export default class ToolbarBtn extends React.PureComponent {
  static propTypes = {
    onClick: PropTypes.func.isRequired,
    title: PropTypes.shape({
      id: PropTypes.string.isRequired,
      defaultMessage: PropTypes.string,
    }),
    disabled: PropTypes.bool,
    className: PropTypes.string,
    buttonText: PropTypes.string,
    children: PropTypes.node,
  };

  static defaultProps = {
    className: '',
    disabled: false,
    buttonText: '',
    title: '',
    children: null,
  };

  render() {
    const {
      onClick,
      title,
      className,
      disabled,
      buttonText,
      children,
      ...rest
    } = this.props;

    return (
      <Button
        data-test-id="YXmb8A1fK6ZYKFnRRGN6d"
        variant="outlined"
        className={classNames(s.btn, className, { [s.disabled]: disabled })}
        onClick={onClick}
        disabled={disabled}
        {...rest}
      >
        {title && <FormattedMessage {...title} />}
        {!title && buttonText}
        {children}
      </Button>
    );
  }
}
